<template>
  <footer>
    <div class="container"
      data-aos="fade-in" data-aos-once="true" data-aos-offset="-100" v-if="footer1 && footer2">
      <div class="columns content is-centered is-gapless is-multiline" style="margin-top:10px;margin-bottom:10px;">
        <p class="column is-8 has-text-left is-hidden-mobile" style="color:white;">
          <markdown v-if="footer1" :source="footer1" />
        </p>
        <p class="column is-4 has-text-right is-hidden-mobile" style="color:white;">
          <markdown v-if="footer2" :source="footer2" />
        </p>
        <p class="column is-12 has-text-centered is-hidden-tablet" style="color:white;">
          <markdown v-if="footer2" :source="footer2" />
        </p>
        <p class="column is-12 has-text-centered is-hidden-tablet" style="color:white;margin-top:20px;">
          <markdown v-if="footer1" :source="footer1" />
        </p>
      </div>
    </div>
    <div v-else style="height:80px;">
      &nbsp;
    </div>
  </footer>
</template>

<script>
import Markdown from 'vue-markdown'
import Site from '@/apis/Site'
export default {
  name: 'footer-main',
  components: {
    Markdown
  },
  data () {
    return {
      footer1: undefined,
      footer2: undefined
    }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target)
      }
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  async mounted () {
    try {
      let data
      data = await Site.infoNamed('footer-1')
      if (data && data[0] && data[0].content) {
        this.footer1 = data[0].content
      } else {
        this.footer1 = undefined
      }
      data = await Site.infoNamed('footer-2')
      if (data && data[0] && data[0].content) {
        this.footer2 = data[0].content
      } else {
        this.footer2 = undefined
      }
    } catch (error) {
      this.footer1 = undefined
      this.footer2 = undefined
      console.log('info error', error)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

footer, .footer {
  background-color: $color-primary-blue;
  padding: 1.2rem 1.2rem 1.2rem;
}

footer {
  .columns {
    .column {
      margin-bottom: 0.2em;
      a {
        font-size: 0.9rem;
        font-family: $font-family;
        // padding: 0.5rem;
        color: $color-white;

        &:hover {
          color: $color-primary-yellow;
        }
      }
    }
  }

  .content p {
    font-family: $font-family;
    font-size: 0.9rem;
  }
}

</style>



// WEBPACK FOOTER //
// Footer.vue?152b3ad6